import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export enum EScaleShape {
    round = 'round',
}

export enum EScaleColor {
    green = 'green',
    orange = 'orange',
    red = 'red',
    black = 'black',
    yellow = 'yellow',
}

@Component({
    selector: 'rating-shape',
    template: `<div class="shape {{shape}} {{color}}"></div>`,
    styleUrls: ['./rating-shape.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingShapeComponent {
    @Input()
    public shape: EScaleShape = EScaleShape.round;

    @Input()
    public color: EScaleColor = EScaleColor.black;
}

